var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58194 4H10.6637V5.06878H11.6532V4H12.7351V7.23644H11.6533V6.15263H10.6638V7.23644H9.58203L9.58194 4ZM14.1576 5.07329H13.2053V4H16.1921V5.07329H15.2394V7.23644H14.1576L14.1576 5.07329ZM16.6661 4H17.7942L18.488 5.13721L19.1812 4H20.3095V7.23644H19.2321V5.63234L18.4879 6.78302H18.4694L17.7247 5.63234V7.23644H16.6661V4ZM20.8479 4H21.93V6.16672H23.4513V7.23644H20.8479V4ZM8 8.71665L9.54737 26.0725L16.4911 28L23.4542 26.0697L25.0032 8.71661L8 8.71665ZM21.636 14.393H13.4904L13.6849 16.5726H21.4423L21.3903 17.1443L20.8581 23.1078L16.5016 24.3153L16.4919 24.3184L12.1315 23.1079L11.8332 19.7657H13.9701L14.1216 21.4633L16.4922 22.1036L16.4942 22.103L18.8684 21.4622L19.1153 18.7014H11.7381L11.164 12.2644H21.8264L21.636 14.393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.97a3c375e9a362f7a081f930259afaa2.svg";
export { ForwardRef as ReactComponent };